import {
  BaSeHeading4,
  BaSeHeading5,
  BaSeInput,
  BaSeSmall2,
  BaSeTheme,
} from '@base/react';
import React from 'react';
import {
  LEFT,
  RANGE_ONE,
  RANGE_SIX,
  RIGHT,
  useNotesRangeController,
} from '../../../../hooks/controllers/notes-range-controller';
import {
  NoteBox,
  NoteSelecionWrap,
  RangeLabel,
} from './calibrate-notes-styled';

export const NotesRange = ({
  track,
  start,
  end,
  onInputChange,
  rangeScore,
  onInputChangePreviousNote,
  onInputChangeNextNote,
  calibrationStatus,
  // eslint-disable-next-line sonarjs/cognitive-complexity
}) => {
  const { completeValue, completeWithZero, applyMask, checkRange } =
    useNotesRangeController();

  const [isValid, setIsValid] = React.useState(false);

  React.useEffect(() => {
    onInputChange((actualValue) => ({
      ...actualValue,
      start: applyMask(
        completeWithZero(start?.toString(), RIGHT, 5),
        track !== RANGE_ONE,
      ),
      end: applyMask(
        completeWithZero(end?.toString(), RIGHT, 5),
        track !== RANGE_SIX,
      ),
    }));
  }, [applyMask, completeWithZero, end, onInputChange, start, track]);

  React.useEffect(() => {
    track && setIsValid(checkRange({ name: track, start: start, end: end }));
  }, [checkRange, end, start, track]);

  return (
    <NoteSelecionWrap>
      <NoteBox>
        <BaSeHeading4
          isBold
          color={BaSeTheme.colors.institucionais.cinzaSebrae30}
        >
          {completeWithZero(rangeScore?.toString(), LEFT, 2)}
        </BaSeHeading4>
      </NoteBox>
      <RangeLabel>
        <BaSeHeading5
          isBold
          color={BaSeTheme.colors.institucionais.cinzaSebrae30}
        >
          De
        </BaSeHeading5>
        <BaSeSmall2 color={BaSeTheme.colors.institucionais.cinzaSebrae75}>
          {`> maior que`}
        </BaSeSmall2>
      </RangeLabel>
      <BaSeInput
        width="70px"
        mask={track !== RANGE_ONE ? 'decimal' : undefined}
        isDisabled={track === RANGE_ONE || !calibrationStatus}
        value={track === RANGE_ONE ? '00' : start}
        color={BaSeTheme.colors.institucionais.cinzaSebrae30}
        inputStatus={isValid ? 'normal' : 'invalid'}
        onChange={(value) =>
          onInputChange((actualValue) => ({
            ...actualValue,
            start: value,
          }))
        }
        onBlur={() => {
          onInputChangePreviousNote((actualValue) => ({
            ...actualValue,
            end: completeValue(start),
          }));
          onInputChange((actualValue) => ({
            ...actualValue,
            start: completeValue(start),
          }));
        }}
      />
      <RangeLabel>
        <BaSeHeading5
          isBold
          color={BaSeTheme.colors.institucionais.cinzaSebrae30}
        >
          Até
        </BaSeHeading5>
        <BaSeSmall2 color={BaSeTheme.colors.institucionais.cinzaSebrae75}>
          {`<= menor ou igual`}
        </BaSeSmall2>
      </RangeLabel>
      <BaSeInput
        width="70px"
        mask={track !== RANGE_SIX ? 'decimal' : undefined}
        isDisabled={track === RANGE_SIX || !calibrationStatus}
        value={track === RANGE_SIX ? '100' : end}
        color={BaSeTheme.colors.institucionais.cinzaSebrae30}
        inputStatus={isValid ? 'normal' : 'invalid'}
        onChange={(value) =>
          onInputChange((actualValue) => ({
            ...actualValue,
            end: value,
          }))
        }
        onBlur={() => {
          onInputChangeNextNote((actualValue) => ({
            ...actualValue,
            start: completeValue(end),
          }));
          onInputChange((actualValue) => ({
            ...actualValue,
            end: completeValue(end),
          }));
        }}
      />
    </NoteSelecionWrap>
  );
};
